import * as yup from 'yup';

const validationSchema = yup.object({
  assignee: yup
    .object()
    .shape({
      text: yup.string().required('Required'),
      value: yup.string().required('Required'),
    })
    .nullable()
    .required('Required'),
  status: yup
    .object()
    .shape({
      text: yup.string().required('Required'),
      value: yup.string().required('Required'),
    })
    .nullable()
    .required('Required'),
  customFields: yup
    .object()
    .shape({
      title: yup.string().required('Required'),
      subscriptionId: yup.string().default(''),
    })
    .nullable()
    .required('Required'),
});

export default validationSchema;
